export enum CustomerStatus {
  Eligible = 'E',
  InQuestion = 'Q',
  Ineligible = 'I'
}

export enum InvestmentStatus {
  Accepted = 'A',
  Draft = 'D',
  Pending = 'P',
  Rejected = 'R',
  Unsigned = 'U'
}

export enum PaymentOptions {
  DirectWithdrawal = 'w',
  PaymentSlip = 's',
  Unspecified = 'u'
}

export enum PitchTypes {
  Archived = 'ar',
  ComingUp = 'cu',
  Draft = 'dr',
  Private = 'pr',
  Public = 'pu',
  Unlisted = 'un'
}
